<template>
  <el-dialog
    :visible="value"
    custom-class="base-dialog base-modal"
    width="1200px"
    @close="$emit('input', false)"
  >
    <div class="vip-dialog">
      <div class="vip-page">
        <div class="vip-package-wrap">
          <p class="vip-package-title">开通会员，获取AI聊天权限</p>
          <p class="vip-package-sub-title">不同套餐，发送的消息次数不同。</p>
          <div class="package-wrap">
            <div class="right-wrap">
              <ul class="flex flex-warp card-warp dis-spb">
                <li
                  v-for="card in list"
                  :key="card.id"
                  :class="{
                    'card-warp-item flex flex-center flex-0 flex-column': true,
                    active: info.id === card.id,
                  }"
                  @click="getPayCode(card)"
                >
                  <p class="p_18">
                    <span class="span_38">¥ {{ card.price * 1 }}</span>
                  </p>
                  <p class="p_0">{{ card.title }}</p>
                  <img
                    class="selectedArrow"
                    src="https://oss.zwk999.com/cdn/images/purchase_icon_choose@2x.png"
                  />
                </li>
                <div class="flex-1"></div>
              </ul>
              <div class="list_bottom flex">
                <div class="list_bottom_left">
                  <div>
                    <ul class="flex flex-warp" style="margin: 0">
                      <li class="flex flex-col-center">
                        <b></b><span>可开发票</span>
                      </li>
                      <li class="flex flex-col-center">
                        <b></b><span>有效期3年</span>
                      </li>
                      <li class="flex flex-col-center">
                        <b></b><span>回复更快</span>
                      </li>
                      <li class="flex flex-col-center">
                        <b></b><span>对话更智能</span>
                      </li>
                      <li class="flex flex-col-center">
                        <b></b><span>电脑手机都可用</span>
                      </li>
                      <li class="flex flex-col-center">
                        <b></b><span>一对一客服</span>
                      </li>
                    </ul>
                  </div>
                  <div><!----></div>
                  <div><!----></div>
                  <p class="p_14 checked-body flex flex-col-center">
                    <el-checkbox
                      v-model="show.checked"
                      class="pointer"
                      type="checkbox"
                      @chagne="getPayCode"
                    />
                    <span @click="show.checked = !show.checked"
                      >开通会员代表您接受</span
                    >
                    <a
                      href="/agreement"
                      target="_blank"
                      @click="show.checked = true"
                    >
                      《订阅会员协议》
                    </a>
                  </p>
                </div>
                <div class="pay-frame">
                  <div class="top">
                    <p class="pay-frame-money">
                      应付金额：<span>￥{{ info.price * 1 }}</span>
                    </p>
                    <div class="tips">
                      <div
                        v-if="show.checked"
                        class="jx-pay-box flex flex-col-center"
                      >
                        <div class="jx-pay-code">
                          <div
                            id="pay_code"
                            ref="pay_code"
                            style="height: 120px; width: 120px"
                          ></div>
                        </div>
                        <div class="jx-pay-code" style="display: none">
                          <i class="el-icon-refresh invalid-text"></i>
                          <div id="qrcode" class="qrcode"></div>
                        </div>
                        <div class="jx-pay-info">
                          <div class="flex flex-col-center">
                            <img
                              alt=""
                              src="data:image/png;base64,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"
                              width="22"
                            /><span>微信扫码支付</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { createOrder, getPayInfo, getVipList, queryOrder } from "@/api";
import QRCode from "qrcodejs2";

export default {
  name: "vip-dialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: {
        checked: true,
      },
      qrcode: null,
      list: [],
      info: {},
      timer: null,
    };
  },
  created() {
    this.getList();
  },
  watch: {
    value() {
      if (this.value) {
        this.getPayCode();
      }
    },
  },
  methods: {
    // 初始化vip列表
    getList() {
      getVipList().then((res) => {
        this.list = res.data.list;
        this.info = res.data.list[0];
        let time = new Date().getTime();
        let time2 = this.info.days * 24 * 60 * 60 * 1000;
        let time3 = time + time2;
        let time4 = new Date(parseInt(time3))
          .toLocaleString()
          .replace(/:\d{1,2}$/, " ");
        let time5 = time4.split(" ");
        this.info.time = time5[0];
      });
    },
    // 获取支付参数
    getPayCode(card) {
      if (card) {
        this.info = card;
      }
      if (this.show.checked) {
        createOrder({ card_id: this.info.id }).then((res) => {
          const order_id = res.data.order_id;
          getPayInfo({ order_id, trade_type: 2 }).then((res) => {
            this.$refs.pay_code.innerHTML = "";
            this.qrcodes = new QRCode(this.$refs.pay_code, {
              width: 120, //二维码宽度
              height: 120, // 二维码高度
              text: res.data.payinfo.code_url, // 二维码内容，这里就是后端返回的字符串
              render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            });
            this.getPayResult(res.data.order_no);
          });
        });
      }
    },
    // 获取支付结果
    getPayResult(order_no) {
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (!this.value) {
          clearInterval(this.timer);
          this.timer = null;
          return;
        }
        queryOrder({ order_no }).then((res) => {
          if (res.data) {
            clearInterval(this.timer);
            this.timer = null;
            this.$message.success("支付成功");
            this.$emit("input", false);
          }
        });
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.vip-dialog {
  .vip-package-wrap {
  }
  .vip-package-title {
    font-size: 36px;
    color: #1a1a1a;
    text-align: center;
    margin: 0 0 20px;
  }
  .vip-package-sub-title {
    font-size: 18px;
    color: #666;
    text-align: center;
    margin-bottom: 10px;
  }
  .package-wrap {
    .card-warp {
      padding: 0;
      margin: -10px;
      li {
        cursor: pointer;
        width: 313px;
        height: 127px;
        flex-shrink: 0;
        margin-bottom: 20px;
        border: 2px solid #e5e5e5;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
      }
    }
    .right-wrap {
      padding: 0 80px;
      .card-warp-item {
        margin: 10px;
      }
      li {
        .selectedArrow {
          z-index: 0;
          position: absolute;
          opacity: 0;
          transition: 0.2s all ease-in;
          width: 38px;
          height: 38px;
          bottom: 0;
          right: 0;
        }
        .p_14 {
          font-size: 14px;
          color: #999;
          margin-top: 13px;
          padding-bottom: 0;
        }
        .p_0 {
          font-size: 14px;
          color: #999;
          margin-top: 0;
        }
        .p_18 {
          font-size: 18px;
          color: #1a1a1a;
        }
        .span_38 {
          font-size: 38px;
          color: #ef5831;
          margin-right: 10px;
        }
        p {
          position: relative;
        }
        &.active {
          .selectedArrow {
            opacity: 1;
          }
        }
      }
    }
  }
  .pay-frame {
    margin-top: 20px;
    .jx-pay-box {
      margin-top: 10px;
    }
    .jx-pay-code {
      padding: 13px 20px 20px 20px;
      .qrcode {
        width: 120px;
        height: 120px;
      }
    }
    .jx-pay-info {
      color: #999;
      font-size: 14px;
      line-height: 30px;
      img {
        margin: 0 5px;
      }
      .daojishi {
        color: #fa4632;
        padding-left: 5px;
      }
    }
    .pay-frame-money {
      color: #1a1a1a;
      font-size: 26px;
      text-align: left;
      padding: 0 20px;
      margin: 0;
      span {
        color: #ef5831;
        margin-right: 20px;
      }
    }
  }
  .list_bottom_left {
    width: 520px;
    padding-top: 69px;
    ul {
      width: 100%;
      li {
        width: 50%;
        font-size: 16px;
        color: #333;
        margin-bottom: 34px;
        b {
          display: inline-block;
          margin-right: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #333333;
        }
      }
    }
  }
  .checked-body {
    font-size: 14px;
    color: #999;
    cursor: pointer;
    a {
      color: #fd6a41;
      text-decoration: underline;
    }
    span {
      padding: 0 5px;
    }
  }
}
</style>
